import { Reducer } from 'redux';
import { ILayoutState, LayoutActionTypes } from './types';

export const startingState: ILayoutState = {
  collapsedNavbar: true,
};

const reducer: Reducer<ILayoutState> = (state = startingState, action) => {
  switch (action.type) {
    case LayoutActionTypes.SET_COLLAPSED_NAVBAR: {
      return { ...state, collapsedNavbar: !state.collapsedNavbar };
    }
    default: {
      return state;
    }
  }
};

export { reducer as layoutReducer };
